<template>
  <div class="paid-member-container">
    <div class="banner">
      <img src="http://static.bjhockey.org/public/pc/image/pc@clubBigBanner.png"/>
    </div>
    <div class="member" v-for="item in organizationList">
      <div class="thumb">
        <img :src="item.profile | ImageFormats" alt="img"  style="object-fit: contain;"/>
      </div>
      <div class="text" v-text="item.name" @click="goDetail(item)"></div>
    </div>

    <el-dialog
      title="简介"
      class="member-dialog"
      :visible.sync="dialogVisible"
      width="30%">
      <div class="desc"><span class="text">名称：</span>{{content.name}}</div>
      <div class="desc"><span class="text">地址：</span>{{content.address}}</div>
      <div class="desc"><span class="text">电话：</span>{{content.mobile}}</div>
      <div class="desc"><span class="text">联系人：</span>{{content.contact}}</div>
      <span slot="footer" class="dialog-footer">
  </span>
    </el-dialog>


  </div>
</template>

<script>
import { ImageFormat } from '@/utils'
import { getOrganizationList } from '@/api/user'

export default {
  name: 'PaidMember',
  data() {
    return {
      organizationList: [],
      dialogVisible: false,
      content: ''
    }
  },
  created() {
    this.getMemberList()
  },
  mounted() {},
  methods: {
    getMemberList() {
      getOrganizationList().then((resolve) => {
        this.organizationList = resolve.data.list
      }, (reject) => {})
    },
    goDetail(content) {
      this.dialogVisible = true
      this.content = content
    }
  },
  filters: {
    ImageFormats(img) {
      return ImageFormat.squareImageView(img, 100, 2)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .paid-member-container {
    margin: 0 auto;
    padding: 15px;
    width: 1200px;
    height: 2600px;
    background-color: #f0f0f0;
    .el-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .el-col {
      border-radius: 4px;
    }
    .bg-purple-dark {
      background: #99a9bf;
    }
    .bg-purple {
      background: #d3dce6;
    }
    .bg-purple-light {
      background: #e5e9f2;
    }
    .grid-content {
      border-radius: 4px;
      min-height: 36px;
    }
    .row-bg {
      padding: 10px 0;
      background-color: #f9fafc;
    }
    .banner {
      width: 100%;
      img {
        width: 1170px;
      }
    }
    .member {
      text-align: center;
      background: #eae8eb;
      width: 272px;
      height: 280px;
      float: left;
      margin: 10px;
      .thumb {
        width: 272px;
        height: 160px;
        padding-top: 30px;
        img {
          width: 100px;
          height: 100px;
        }
      }
      .text {
        height: 120px;
        background: #FFF;
        padding-top: 30px;
        padding-left: 5px;
        padding-right: 5px;
        &:hover {
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
    .el-dialog {
      min-width: 320px;
    }
    .member-dialog {
      .desc {
        padding: 5px 10px;
        .text {
          font-weight: bold;
        }
      }
    }
  }
</style>
